import { render, staticRenderFns } from "./GalleriesPricelist.vue?vue&type=template&id=489e9608&scoped=true&"
import script from "./GalleriesPricelist.vue?vue&type=script&lang=js&"
export * from "./GalleriesPricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e9608",
  null
  
)

export default component.exports